import useCustomerFoodDetail from "../hooks/useCustomerFoodDetail";
import { getFoodDetailThemeComponent } from "./foodDetail/themes/registry";

export default function FoodDetailPage() {
  const detail = useCustomerFoodDetail();
  const { item, menuLink, theme, goBack } = detail;

  if (!item || !menuLink) {
    return (
      <main className="flex min-h-screen items-center justify-center bg-gray-50 p-4 text-center" dir="rtl">
        <div><p className="font-bold text-gray-800">این آیتم در دسترس نیست.</p><button type="button" onClick={goBack} className="mt-4 text-sm font-bold text-primary">بازگشت</button></div>
      </main>
    );
  }

  const ThemeComponent = getFoodDetailThemeComponent(theme);
  return <ThemeComponent {...detail} />;
}
